import React, { useContext, useState, useCallback, useEffect } from "react";
import { getIcon } from "../../utils/images";
import "./Filters.scss";
import { Button } from "antd";
import SwitchFilter from "./Filter/SwitchFilter/SwitchFilter";
import AccordionFilter from "./Filter/AccordionFilter/AccordionFilter";
import DatePickerFilter from "./Filter/DatePickerFilter/DatePickerFilter";
import { useFetch } from "../../utils/hooks";
import { getShipmentFilters } from "../../services/shipments";
import { getStateColorMap } from "../../utils/utils";
import FilterCounterContext from "./FilterCounterContext";
import { useLocation } from "react-router-dom";

const Filters = ({ filterList, close, setFilterList, archive = false }) => {
  const location = useLocation();
  // Extract "as" parameter from URL
  const searchParams = new URLSearchParams(location.search);
  const asParam = searchParams.get('as'); // This will extract the "as" parameter
  const { data } = useFetch(useCallback(() => getShipmentFilters({ archive, as: asParam }), [filterList]))
  const filters = data?.filters
  const [temporaryFilterList, setTemporaryFilterList] = useState({
    ...filterList,
    attention: filterList.attention === undefined ? false : filterList.attention,
    starred: filterList.starred === undefined ? false : filterList.starred,
    nowlun: filterList.nowlun === undefined ? false : filterList.nowlun,
    tracking: filterList.tracking === undefined ? false : filterList.tracking,
    etd_start: filterList.etd_start,
    etd_end: filterList.etd_end,
    eta_start: filterList.eta_start,
    eta_end: filterList.eta_end,
    gate_out_start: filterList.gate_out_start,
    gate_out_end: filterList.gate_out_end,
    empty_return_start: filterList.empty_return_start,
    empty_return_end: filterList.empty_return_end
  })
  const { setFilterCounter } = useContext(FilterCounterContext);

  function addToList(key, value) {
    const params = {
      ...temporaryFilterList
    }
    if (!params[key]) params[key] = []
    params[key].push(value)
    setTemporaryFilterList(params)
  }

  function removeFromList(key, value) {
    const params = {
      ...temporaryFilterList
    }
    if (params[key]) {
      let index = params[key].indexOf(value);
      if (index !== -1) {
        params[key].splice(index, 1);
      }
    }
    setTemporaryFilterList(params)
  }

  function countActiveFilters() {
    let count = 0;
    for (let [key, val] of Object.entries(temporaryFilterList)) {
      if (["attention", "starred", "eta_start", "etd_start", "eta_end", "etd_end", "gate_out_start", "gate_out_end", "empty_return_start", "empty_return_end"].includes(key) && val) {
        count += 1;
      } else if (["pol", "pod", "status", "line"].includes(key)) {
        count += val.length;
      }
    }
    setFilterCounter(count);
  }

  function closeFilterModal() {
    document.getElementsByClassName("wrapper-open")[0].classList.add("wrapper-close")
    setTimeout(() => close(), 1000)    
  }

  function handleFilter() {
    setFilterList(temporaryFilterList)
    countActiveFilters()
    window.dispatchEvent(new Event('filter'));
    closeFilterModal()
  }

  const filterMenus = [
    { specialKey: "pol", title: "Port of Loading", items: filters?.pol },
    { specialKey: "pod", title: "Port of Destination", items: filters?.pod },
    { specialKey: "status", title: "Status", items: filters?.status.map(state => [getStateColorMap(state).title, state]) },
    { specialKey: "line", title: "Shipping Line", items: filters?.line },
  ]

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    return () => { document.body.style.overflowY = 'auto'; }
  }, [filterList])

  return (
    <div className="Filters">
      <div className="overlay"></div>
      <div className="filters-wrapper wrapper-open">
        <div className="header">
          <div>
            <img src={getIcon('close')} onClick={closeFilterModal} />
          </div>
          <div className="header__title">
            Filter
          </div>
        </div>
        <div className="items">
          <SwitchFilter title={"Attention Only"} specialKey={"attention"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <SwitchFilter title={"Starred Only"} specialKey={"starred"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <SwitchFilter title={"Nowlun Only"} specialKey={"nowlun"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <SwitchFilter title={"Tracking Only"} specialKey={"tracking"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          {filterMenus.map(menu => menu.items && <AccordionFilter key={menu.specialKey} specialKey={menu.specialKey} title={menu.title} items={menu.items} temporaryFilterList={temporaryFilterList} addToList={addToList} removeFromList={removeFromList} />)}
          <DatePickerFilter title={"ETD"} startSpecialKey={"etd_start"} endSpecialKey={"etd_end"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <DatePickerFilter title={"ETA"} startSpecialKey={"eta_start"} endSpecialKey={"eta_end"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <DatePickerFilter title={"Gate Out"} startSpecialKey={"gate_out_start"} endSpecialKey={"gate_out_end"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
          <DatePickerFilter title={"Empty Return"} startSpecialKey={"empty_return_start"} endSpecialKey={"empty_return_end"} temporaryFilterList={temporaryFilterList} setTemporaryFilterList={setTemporaryFilterList} />
        </div>

        <div className="submit">
          <Button className="bold-btn" onClick={handleFilter}>Filter</Button>
        </div>
      </div>
    </div>
  )
}

export default Filters;
